import { render, staticRenderFns } from "./NineSquares.vue?vue&type=template&id=360d587c&scoped=true"
import script from "./NineSquares.vue?vue&type=script&lang=js"
export * from "./NineSquares.vue?vue&type=script&lang=js"
import style0 from "./NineSquares.vue?vue&type=style&index=0&id=360d587c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360d587c",
  null
  
)

export default component.exports